import { createFileRoute } from '@tanstack/react-router';
import { SegmentsIndexPage } from '../../../features/B5/scope-settings-page';

/** W2-2-3: /settings/segments — one segment today, so straight to its page. */
export const Route = createFileRoute('/_app/settings/segments/')({
  component: SegmentsIndexPage,
});
